export const configData = [
  {
    name: "Code Workflow",
    main_Router: "Code Workflow",
    path: "Code-Workflow",
    children: [
      {
        name: "HIM Workspace",
        path: "HIM-Workspace",
        children: [
          {
            name: "Outstanding Report",
            path: "outstanding-report",
          },
        ],
      },
      {
        name: "Coder Workspace",
        path: "Coder-Workspace",
      },
      {
        name: "Auditor Workspace",
        path: "Auditor-Workspace",
      },
    ],
  },
  {
    name: "Code Assist",
    main_Router: "Code Assist",
    children: [
      {
        name: "Episode List",
        path: "Code-Assist-Episode-list",
      },
      {
        name: "Coder",
        path: "Code-Assist",
      },
    ],
  },
  {
    name: "Code Accelerate",
    main_Router: "Code Accelerate",
    children: [
      {
        name: "Episode List",
        path: "Episode-list",
      },
      {
        name: "Coder",
        path: "Coder",
        children: [
          {
            name: "Upload Documents",
            path: "upload-document",
            children: [
              {
                name: "Upload",
                path: "upload-type-document",
              },
            ],
          },
        ],
      },
    ],
  },

  {
    name: "Code Enhance",
    main_Router: "Code Enhance",
    children: [
      {
        name: "Discovery",
        path: "Discovery",
        children: [
          {
            name: "View Dashboard",
            path: "viewdashboard",
          },
        ],
      },
      {
        name: "Workflow",
        path: "Workflow",
        children: [
          {
            name: "Workflow Dashboard",
            path: "workflow-dashboard",
          },
        ],
      },
    ],
  },
  {
    name: "Codie",
    main_Router: "Codie",
    children: [
         {
            name: "Chat AI",
            path: "ChatAi",
          },
          {
            name: "Advice Search",
            path: "SearchCodingAdvice",
          },
    ],
    path: "Codie",
  },
  {
    name: "Settings",
    main_Router: "Settings",
    children: [
      {
        name: "General",
        path: "General",
        children: [
          {
            name: "ChangePassword",
            path: "ChangePassword",
          },
          {
            name: "UpdateMail",
            path: "UpdateMail",
          },
          {
            name: "UploadDocuments",
            path: "settings-upload-document",
            children: [
              {
                name: "Upload",
                path: "upload-type-document",
              },
            ],
          },
        ],
      },
      {
        name: "Accelerate Settings",
        path: "Accelerate-settings",
      },
      {
        name: "Assist Settings",
        path: "Assist-settings",
      },
      {
        name: "Workflow Settings",
        path: "Workflow-settings",
        children: [
          {
            name: "System Configuration",
            path: "System-configuration",
          },
          {
            name: "User Management",
            path: "User-Management",
          },
        ],
      },
      {
        name: "Enhance Settings",
        path: "Enhance-settings",
      },
    ],
  },
  {
    name: "Admin",
    main_Router: "Admin",
    children: [
      {
        name: "Users",
        path: "Users",
      },
      {
        name: "Approved Users",
        path: "Approved-Users",
      },
      {
        name: "Roles",
        path: "Roles",
      },
      {
        name: "Modules",
        path: "Modules",
      },
      {
        name: "Module Permissions",
        path: "Module-Permissions",
      },
      {
        name: "Role Assignments",
        path: "Role-Assignments",
      },
      {
        name: "Organizations",
        path: "Organizations",
      },
      {
        name: "Countries",
        path: "Countries",
      },
    ],
    path: "admin",
  },
];
